export type ApiResponseAutonomousAgentDetail = {
    id: number,
    name: string,
    phone: string,
  }

  export class AutonomousAgentDetail {
    id: number
    name: string
    phone: string

    constructor(apiResponseAutonomousAgentDetail: ApiResponseAutonomousAgentDetail) {
      this.id = apiResponseAutonomousAgentDetail.id;
      this.name = apiResponseAutonomousAgentDetail.name;
      this.phone = apiResponseAutonomousAgentDetail.phone;
    }
  }
